import { type RefSelectProps } from 'antd'
import { type Ref, forwardRef } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { useDcsSelectQuery } from '@/features/dcs/hooks'
import { type DcEntity } from '@/libs/api'

import { DcSelect } from './DcSelect'

type Props = SingleOrMultipleSelectProps<number, DcEntity> & {
  tenantKey: string
  needDefaultDcId?: boolean
}

/**
 * すべての拠点からを選択するSelect
 */
export const AllDcSelect = forwardRef(
  ({ tenantKey, ...props }: Props, ref: Ref<RefSelectProps> | undefined) => {
    const { data: allDcs } = useDcsSelectQuery(tenantKey, {
      orders: ['code.asc']
    })

    return <DcSelect ref={ref} {...props} options={allDcs} />
  }
)
